import PlanningCancellationDecisionEnum from './PlanningCancellationDecisionEnum';

const PlanningCancellationDecisionOptionsArray = [
  { value: PlanningCancellationDecisionEnum.BareDecision, label: 'BARE decision' },
  { value: PlanningCancellationDecisionEnum.ClientDecision, label: 'Client decision' },
  { value: PlanningCancellationDecisionEnum.Other, label: 'Other' },
];

export default PlanningCancellationDecisionOptionsArray;
